import './HomeScreen.css'
import IncomingEventsSection from './components/incoming-events-section'
import MeasurementsArticle from './components/measurements-article'
import LoadingIndicator from '../../components/LoadingIndicator'
import Button from '../../components/Button'
import ProfileWorkoutsSection from './components/profile-workouts-section'
import PlanWorkoutsSection from './components/plan-workout-article'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { useGetActiveWorkoutQuery, useGetCurrentMemberQuery } from 'src/graphql'
import HistoryWorkoutsScreen from '../HistoryWorkoutsScreen'

const HomeScreen = () => {

    const { data: activeWorkoutData, loading: loadingActiveWorkout } = useGetActiveWorkoutQuery();
    const { data: memberData, loading: loadingCurrentMember } = useGetCurrentMemberQuery();

    const loading = loadingActiveWorkout && loadingCurrentMember
    const lastMeasurement = memberData?.getCurrentMember?.measurement

    const { t } = useTranslation();
    const navigate = useNavigate()


    if (loading) {
        return <LoadingIndicator />
    }

    return (
        <div className="grid-container">
            {activeWorkoutData?.getActiveWorkout && <section>
                <article>
                    <h1 className='-mb-2'>קיים אימון פעיל</h1>
                    <p className='pb-2'>שם האימון: <span className='font-bold'>{activeWorkoutData.getActiveWorkout.name}</span></p>
                    <Button onClick={() => navigate('/active')}>חזור לאימון</Button>
                </article>
            </section>}

            {memberData?.getCurrentMember?.plans?.items?.[0] && <PlanWorkoutsSection plan={memberData.getCurrentMember.plans.items[0] as any} workouts={memberData?.getCurrentMember?.plans?.items?.[0].workouts?.items || []} />}
            <ProfileWorkoutsSection workouts={memberData?.getCurrentMember?.profile_workouts?.items || []} />

            {memberData?.getCurrentMember?.plans?.items?.[0] && <IncomingEventsSection events={memberData?.getCurrentMember?.plans?.items?.[0].events?.items || []} />}

            <HistoryWorkoutsScreen />

            <section id='summary'>
                <MeasurementsArticle measurement={lastMeasurement || {}} />
            </section>

            <section id="Consistency-Graph">
                <article>
                    <h1 className='orange'>{t("consistency_graph")}</h1>

                    <div>
                        <div className='py-6 flex-row flex items-end justify-center gap-x-3'>
                            <div className='flex flex-col items-center'>
                                <p className='bg-blue h-12 w-5'></p>
                                <p className='light'>{t("april").substring(0, 3)}</p>
                            </div>
                            <div className='flex items-center flex-col'>
                                <p className='bg-blue h-16 w-5'></p>
                                <p className='light'>{t("may").substring(0, 3)}</p>
                            </div>
                            <div className='flex items-center flex-col'>
                                <p className='bg-blue h-10 w-5'></p>
                                <p className='light'>{t("june").substring(0, 3)}</p>
                            </div>
                            <div className='flex items-center flex-col'>
                                <p className='bg-blue h-16 w-5'></p>
                                <p className='light'>{t("july").substring(0, 3)}</p>
                            </div>
                            <div className='flex items-center flex-col'>
                                <p className='bg-[#FDA046] h-20 w-5'></p>
                                <p className='light'>{t("august").substring(0, 3)}</p>
                            </div>
                            <div className='flex items-center flex-col'>
                                <p className='bg-blue h-24 w-5'></p>
                                <p className='light'>{t("september").substring(0, 3)}</p>
                            </div>
                        </div>
                        <div className='flex items-center gap-x-2'>
                            <div className='bg-[#FDA046] w-3 h-3 rounded-full'></div>
                            <p className='text-dark text-xs font-medium'>{t("current_month")}</p>
                        </div>
                    </div>
                </article>
            </section>
        </div>
    )
}

export default HomeScreen